<template>
  <nx-bform-group class="bd-black" :label="name" v-bind="$attrs">
    <slot>
      <b-input-group class="login-password-form-field">
        <nx-bform-input
            name="OTP"
            :rules="{ required: required }"
            :value="$attrs.value"
            @input="$listeners.input"
            :aria-label="name"
        />
        <template #append>
          <b-button class="request_btn"  aria-label="View password" @click="$emit('requestOTP')">
           Request OTP
          </b-button>
        </template>
      </b-input-group>
    </slot>
  </nx-bform-group>
</template>

<script>
import FormGroupMixin from "../../form-group.mixin";

export default {
  mixins: [FormGroupMixin],
  computed: {
    name() {
      return this.label;
    }
  }
};
</script>

<style lang="scss" scoped>
.request_btn{
  background-color: #CC4400;
  border: none;
}
.request_btn:hover, .request_btn:focus {
  background-color: #005d99;
}
</style>

